var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useNavigate } from "react-router-dom";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
import dayjs from "dayjs";
import { Box, Chip, Stack, Typography, useMediaQuery } from "@mui/material";
import { DynamicCatalogBuilder } from "../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { FieldFailureReportsKeys } from "../../../fieldFailureReports/services/entity";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import FFRReportDetailsView from "./FFRCatalogDesktopView";
import { SubmitionPopUp } from "../../../fieldFailureReports/components/submitPopUp";
import FFRDetailsMobileView from "./FFRCatalogMobileView";
import { RowSelectionPopup } from "./FFRRowSelectionPopup";
// import { fieldFailureReportsPagingAPI } from "../../../fieldFailureReports/services/apiCalls";
import InfiniteScroll from "../../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
import { systemColor } from "../../../../theme/systemColor";
import { dateFormate } from "../../../../utils/utils";
import ActionMenuList from "../../../../builderPackage/components/actionsMenuList";
import { ASMRemarks } from "./components/SingleAsmregardsPopu";
import { fieldFailureReportsPagingAPI } from "../../services/apiCalls";
import { AreaFieldReportsKeys } from "../../services/entity";
var FFRCatalogueComponent = function (props) {
    var _crud, _crud2;
    var onSelectionChange = props.onSelectionChange, rowData = props.rowData;
    var navigate = useNavigate();
    var value = props.value;
    var dispatch = useAppDispatch();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var hasMore = !crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")] || ((_crud = crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")]) === null || _crud === void 0 || (_crud = _crud.data) === null || _crud === void 0 ? void 0 : _crud.length) < ((_crud2 = crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")]) === null || _crud2 === void 0 ? void 0 : _crud2.count);
    var ActionItem = function (id, row) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedRow, _a, _b, reportId, res, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    updatedRow = _objectSpread(_objectSpread({}, row), {}, {
                        ActionTaken: id
                    });
                    _a = id;
                    switch (_a) {
                        case "view": return [3 /*break*/, 1];
                        case "edit": return [3 /*break*/, 6];
                        case "submit": return [3 /*break*/, 7];
                        case "ResendToDealer": return [3 /*break*/, 9];
                        case "Accept": return [3 /*break*/, 14];
                        case "CloseToFFR": return [3 /*break*/, 19];
                    }
                    return [3 /*break*/, 24];
                case 1:
                    if (!lgMode) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Drawer",
                            Component: FFRReportDetailsView,
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        maxWidth: {
                                            sm: "90%",
                                            md: 750
                                        }
                                    }
                                },
                                anchor: "right"
                            },
                            componentProps: {
                                data: row
                            }
                        }))];
                case 2:
                    _b = _f.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: FFRDetailsMobileView,
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    maxHeight: {
                                        sm: 400,
                                        md: 400
                                    },
                                    height: {
                                        sm: 400,
                                        md: 400
                                    }
                                }
                            },
                            anchor: "bottom"
                        },
                        componentProps: {
                            data: row
                        }
                    }))];
                case 4:
                    _b = _f.sent();
                    _f.label = 5;
                case 5:
                    _b;
                    return [3 /*break*/, 25];
                case 6:
                    {
                        reportId = row === null || row === void 0 ? void 0 : row.id;
                        if (reportId) {
                            navigate("/areaFieldReports/ffr/".concat(reportId));
                        }
                        return [3 /*break*/, 25];
                    }
                    _f.label = 7;
                case 7: return [4 /*yield*/, dispatch(showSurface({
                        type: "Dialog",
                        Component: SubmitionPopUp,
                        containerProps: {
                            maxWidth: "xs"
                        },
                        componentProps: {
                            data: {
                                row: row
                            }
                        }
                    }))];
                case 8:
                    res = _f.sent();
                    return [3 /*break*/, 25];
                case 9:
                    if (!lgMode) return [3 /*break*/, 11];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: ASMRemarks,
                            containerProps: {
                                maxWidth: "xs"
                            },
                            componentProps: {
                                row: updatedRow
                            }
                        }))];
                case 10:
                    _c = _f.sent();
                    return [3 /*break*/, 13];
                case 11: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: ASMRemarks,
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    maxHeight: {
                                        sm: 400,
                                        md: 400
                                    },
                                    height: {
                                        sm: 400,
                                        md: 400
                                    }
                                }
                            },
                            anchor: "bottom"
                        },
                        componentProps: {
                            data: {
                                row: row
                            }
                        }
                    }))];
                case 12:
                    _c = _f.sent();
                    _f.label = 13;
                case 13:
                    _c;
                    return [3 /*break*/, 25];
                case 14:
                    if (!lgMode) return [3 /*break*/, 16];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: ASMRemarks,
                            containerProps: {
                                maxWidth: "xs"
                            },
                            componentProps: {
                                row: updatedRow
                            }
                        }))];
                case 15:
                    _d = _f.sent();
                    return [3 /*break*/, 18];
                case 16: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: ASMRemarks,
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    maxHeight: {
                                        sm: 400,
                                        md: 400
                                    },
                                    height: {
                                        sm: 400,
                                        md: 400
                                    }
                                }
                            },
                            anchor: "bottom"
                        },
                        componentProps: {
                            data: {
                                row: row
                            }
                        }
                    }))];
                case 17:
                    _d = _f.sent();
                    _f.label = 18;
                case 18:
                    _d;
                    return [3 /*break*/, 25];
                case 19:
                    if (!lgMode) return [3 /*break*/, 21];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: ASMRemarks,
                            containerProps: {
                                maxWidth: "xs"
                            },
                            componentProps: {
                                row: updatedRow
                            }
                        }))];
                case 20:
                    _e = _f.sent();
                    return [3 /*break*/, 23];
                case 21: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: ASMRemarks,
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    maxHeight: {
                                        sm: 400,
                                        md: 400
                                    },
                                    height: {
                                        sm: 400,
                                        md: 400
                                    }
                                }
                            },
                            anchor: "bottom"
                        },
                        componentProps: {
                            data: {
                                row: row
                            }
                        }
                    }))];
                case 22:
                    _e = _f.sent();
                    _f.label = 23;
                case 23:
                    _e;
                    return [3 /*break*/, 25];
                case 24:
                    console.warn("Unhandled action id:", id);
                    _f.label = 25;
                case 25: return [2 /*return*/];
            }
        });
    }); };
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center",
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: "",
                            columnSize: 8,
                            justifyContent: "center",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.CheckBox,
                                    name: "IsParent",
                                    label: "",
                                    value: null,
                                    columnSize: true,
                                    setFormState: function (formValue) {
                                        console.log("currentValue", formValue);
                                        handleRowChange(formValue);
                                        return {};
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "DocumentName",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: "base",
                                        fontWeight: "medium"
                                    },
                                    fontSize: "base",
                                    fontWeight: "medium",
                                    color: systemColor.black
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "DocumentDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.DocumentDate ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.DocumentDate)) : "-"; },
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: "base",
                                        fontWeight: "medium",
                                        color: "text.tertiary"
                                    },
                                    fontSize: "sm",
                                    fontWeight: "normal",
                                    color: systemColor.lightGrey
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: "",
                            columnSize: 4,
                            justifyContent: "flex-end",
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: "Status",
                                    variant: "outlined",
                                    size: "small",
                                    columnSize: 0,
                                    color: "info",
                                    sx: {
                                        borderRadius: "6px"
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: "More",
                                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                                    size: "small",
                                    variant: "text",
                                    color: "secondary",
                                    sx: {
                                        p: "7px"
                                    },
                                    columnSize: 0,
                                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var action;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: "Menu",
                                                        containerProps: {
                                                            anchorEl: e.target.parentElement
                                                        },
                                                        Component: ActionMenuList,
                                                        componentProps: {
                                                            items: [{
                                                                    id: "ResendToDealer",
                                                                    children: "Resend to Dealer"
                                                                }, {
                                                                    id: "Accept",
                                                                    children: "Accept & group"
                                                                }, {
                                                                    id: "CloseToFFR",
                                                                    children: "Close FFR",
                                                                    disabled: (state === null || state === void 0 ? void 0 : state.Status) == "Closed by ASM"
                                                                }, {
                                                                    id: "edit",
                                                                    children: "Edit",
                                                                    disabled: (state === null || state === void 0 ? void 0 : state.Status) === "Open" ? false : true
                                                                }, {
                                                                    id: "view",
                                                                    children: "View"
                                                                }, {
                                                                    id: "print",
                                                                    children: "Print"
                                                                }, {
                                                                    id: "download",
                                                                    children: "Download"
                                                                }, {
                                                                    id: "share",
                                                                    children: "Share"
                                                                }]
                                                        }
                                                    }))];
                                                case 1:
                                                    action = _a.sent();
                                                    ActionItem(action.payload, state);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: "expamd",
                    sx: {
                        bgcolor: "secondary.50",
                        border: "none"
                    },
                    contentProps: {
                        spacing: 1,
                        p: 1,
                        rowSpacing: 0
                    },
                    containerProps: {
                        my: 0
                    },
                    elements: __spreadArray(__spreadArray([], [{
                            label: "Part",
                            codeField: "PartCode",
                            nameField: "PartName"
                        }, {
                            label: "Model",
                            codeField: "ModelCode",
                            nameField: "ModelName"
                        }, {
                            label: "Defect",
                            codeField: "DefectCode",
                            nameField: "DefectDescription"
                        }].map(function (item) { return ({
                        type: FormItemTypes.ContainerItem,
                        name: "",
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: "",
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                columnSize: true,
                                display: "flex",
                                justifyContent: "flex-end",
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.codeField,
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: "vertical",
                                        name: "",
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.nameField,
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    }); }), true), [{
                            type: FormItemTypes.Accordian,
                            name: "expanded",
                            value: false,
                            summaryProps: {
                                sx: {
                                    display: "none"
                                }
                            },
                            summary: [],
                            detailPanelProps: {
                                spacing: 1
                            },
                            sx: {
                                bgcolor: "background.secondary",
                                border: "none"
                            },
                            columnSize: 12,
                            setFieldProps: function (state, currValue, field) {
                                return {
                                    type: this.type,
                                    elements: __spreadArray([], [{
                                            name: "Branch",
                                            label: "Branch : "
                                        }, {
                                            name: "ChasisNumber",
                                            label: "Chassis No: "
                                        }, {
                                            name: "RepairType",
                                            label: "Repair Type:"
                                        }, {
                                            name: "Ageing",
                                            label: "Ageing :"
                                        }, {
                                            name: "Intensity",
                                            label: "Intensity :"
                                        }, {
                                            name: "Source",
                                            label: "Source :"
                                        }, {
                                            name: "Identification",
                                            label: "Identification :"
                                        }].map(function (item) { return ({
                                        type: FormItemTypes.Typography,
                                        name: item.name,
                                        label: item.label,
                                        fontSize: "sm",
                                        fontWeight: "medium",
                                        columnSize: 12,
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        containerProps: {
                                            display: "flex",
                                            direction: "row",
                                            justifyContent: "space-between"
                                        },
                                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.name]) || "-"; }
                                    }); }), true)
                                };
                            },
                            elements: []
                        }], false)
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: "end",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "expand-button",
                            columnSize: 0,
                            color: "secondary",
                            size: "small",
                            sx: {
                                p: 0,
                                fontSize: "sm"
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ["Hide", /*#__PURE__*/ React.createElement(ExpandLess, null)] : ["View more", /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    var pagingColumns = [{
            type: "string",
            field: "DocumentName",
            headerName: "Document Name",
            headerAlign: "center",
            width: 250,
            align: "center"
        }, {
            type: "date",
            field: "DocumentDate",
            valueFormatter: function (params) { return dayjs(params).format("DD-MM-YYYY"); },
            headerName: "Document Date",
            width: 150,
            headerAlign: "center",
            align: "center"
        }, {
            type: "date",
            field: "ReportDate",
            valueFormatter: function (params) { return dayjs(params).format("DD-MM-YYYY"); },
            headerName: "Report Date",
            width: 200,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Branch",
            headerName: "Branch",
            width: 250,
            headerAlign: "center",
            align: "center"
        }, {
            field: "ChasisNumber",
            headerName: "Chassis No",
            width: 200,
            headerAlign: "center",
            align: "center"
        }, {
            field: "PartName",
            headerName: "Part",
            width: 200,
            headerAlign: "center",
            renderCell: function (params) {
                var _params$row$PartName, _params$row, _params$row$PartCode, _params$row2;
                var partName = (_params$row$PartName = (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.PartName) !== null && _params$row$PartName !== void 0 ? _params$row$PartName : ' ';
                var partCode = (_params$row$PartCode = (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.PartCode) !== null && _params$row$PartCode !== void 0 ? _params$row$PartCode : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, partName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, partCode));
            },
            align: "center"
        }, {
            field: "ModelName",
            headerName: "Model",
            width: 200,
            headerAlign: "center",
            renderCell: function (params) {
                var _params$row$ModelName, _params$row3, _params$row$ModelCode, _params$row4;
                var ModelName = (_params$row$ModelName = (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ModelName) !== null && _params$row$ModelName !== void 0 ? _params$row$ModelName : " ";
                var ModelCode = (_params$row$ModelCode = (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ModelCode) !== null && _params$row$ModelCode !== void 0 ? _params$row$ModelCode : " ";
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, ModelName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, ModelCode));
            },
            align: "center"
        }, {
            field: "DefectDescription",
            headerName: "Defect",
            width: 200,
            headerAlign: "center",
            renderCell: function (params) {
                var _params$row$DefectDes, _params$row5, _params$row$DefectCod, _params$row6;
                var DefectDescription = (_params$row$DefectDes = (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.DefectDescription) !== null && _params$row$DefectDes !== void 0 ? _params$row$DefectDes : " ";
                var DefectCode = (_params$row$DefectCod = (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.DefectCode) !== null && _params$row$DefectCod !== void 0 ? _params$row$DefectCod : " ";
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, DefectDescription), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, DefectCode));
            },
            align: "center"
        }, {
            field: "RepairType",
            headerName: "Repair Type",
            width: 150,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Ageing",
            headerName: "Ageing",
            width: 100,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Intensity",
            headerName: "Intensity",
            width: 150,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Source",
            headerName: "Source",
            width: 150,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Identification",
            headerName: "Identification",
            width: 200,
            headerAlign: "center",
            align: "center"
        }, {
            field: "Status",
            headerName: "Status",
            width: 200,
            headerAlign: "left",
            align: "left",
            renderCell: function (prisma) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    color: "info",
                    sx: {
                        borderRadius: 1,
                        px: 1,
                        fontWeight: "medium",
                        fontSize: 12
                    },
                    label: prisma.value
                });
            }
        }, {
            type: "actions",
            field: "Actions",
            headerName: "",
            getActions: function (_ref) {
                var row = _ref.row;
                return [{
                        id: "ResendToDealer",
                        children: "Resend to dealer",
                        onClick: function (event) {
                            dispatch(showSurface({
                                type: "Dialog",
                                Component: RowSelectionPopup,
                                containerProps: {
                                    fullWidth: true
                                },
                                componentProps: {
                                    selectedRows: rowData
                                }
                            }));
                            return;
                        }
                    }, {
                        id: "Accept",
                        children: "Accept"
                    }, {
                        id: "CloseToFFR",
                        children: "Close FFR"
                    }, {
                        id: "edit",
                        children: "Edit",
                        disabled: row === null || row === void 0 ? void 0 : row.IsSubmit
                    }, {
                        id: "view",
                        children: "View",
                        divider: true
                    }, {
                        id: "print",
                        children: "Print"
                    }, {
                        id: "download",
                        children: "Download PDF"
                    }, {
                        id: "share",
                        children: "Share"
                    }].map(function (it) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    showInMenu: true,
                    id: it.id,
                    label: it.children,
                    divider: it.divider,
                    disabled: it.disabled,
                    onClick: function () { return ActionItem(it.id, row); }
                }); });
            }
        }];
    var handleRowChange = function (selectedRowsMap) {
        var selectedRows;
        if (selectedRowsMap instanceof Map) {
            selectedRows = Array.from(selectedRowsMap.values());
            selectedRows = selectedRows.filter(function (row, index, self) { return index === self.findIndex(function (r) { return r.id === row.id; }); });
        }
        else {
            var isAlreadySelected = rowData.some(function (row) { return row.id === selectedRowsMap.id; });
            if (isAlreadySelected) {
                selectedRows = rowData.filter(function (row) { return row.id !== selectedRowsMap.id; });
            }
            else {
                selectedRows = __spreadArray(__spreadArray([], rowData, true), [selectedRowsMap], false);
            }
        }
        if (onSelectionChange) {
            onSelectionChange(selectedRows);
        }
    };
    return lgMode ? /*#__PURE__*/ React.createElement(Stack, {
        minHeight: 100
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: AreaFieldReportsKeys.FFRPaging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "ReceivedToASM"),
        pagingAPIRequest: {
            DataRange: value === null || value === void 0 ? void 0 : value.DataRange,
            FromDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.FromDate : undefined,
            ToDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.ToDate : undefined,
            search: value === null || value === void 0 ? void 0 : value.search,
            status: (value === null || value === void 0 ? void 0 : value.SelectedButton) === "ReceivedToASM" ? "ReceivedToASM" : value === null || value === void 0 ? void 0 : value.SelectedButton
        },
        getPagingData: fieldFailureReportsPagingAPI,
        columns: pagingColumns,
        dataGridProps: {
            sx: {
                marginX: 3
            },
            checkboxSelection: true,
            rowSelection: true,
            onRowSelectionModelChange: function (selectedRow, details) {
                handleRowChange(details.api.getSelectedRows());
            },
            disableColumnSelector: true,
            cellSelection: false,
            onCellClick: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(params.field === "DocumentName")) return [3 /*break*/, 5];
                            if (!lgMode) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch(showSurface({
                                    type: "Drawer",
                                    Component: FFRReportDetailsView,
                                    containerProps: {
                                        PaperProps: {
                                            sx: {
                                                maxWidth: {
                                                    sm: "90%",
                                                    md: 750
                                                }
                                            }
                                        },
                                        anchor: "right"
                                    },
                                    componentProps: {
                                        data: params.row
                                    }
                                }))];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, dispatch(showSurface({
                                type: "Drawer",
                                Component: FFRDetailsMobileView,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            maxHeight: {
                                                sm: 400,
                                                md: 400
                                            },
                                            height: {
                                                sm: 400,
                                                md: 400
                                            }
                                        }
                                    },
                                    anchor: "bottom"
                                },
                                componentProps: {
                                    data: params.row
                                }
                            }))];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            _a;
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); },
            disableColumnPinning: false,
            initialState: {
                pinnedColumns: {
                    left: ["__check__", "DocumentName"],
                    right: ["Status", 'Actions']
                },
                density: "standard"
            }
        }
    })) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: fieldFailureReportsPagingAPI,
        apiKey: AreaFieldReportsKeys.FFRPaging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "ReceivedToASM"),
        apiRequest: {
            DataRange: value === null || value === void 0 ? void 0 : value.DataRange,
            FromDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.FromDate : undefined,
            ToDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.ToDate : undefined,
            search: value === null || value === void 0 ? void 0 : value.search,
            status: value === null || value === void 0 ? void 0 : value.SelectedButton
        },
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        },
        elements: formData
    });
};
export default FFRCatalogueComponent;
